"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBasicFlashcardInfo = exports.BasicFlashcardInfoSchema = exports.FlashcardBaseSchema = exports.FlashcardWithoutPicturesBaseSchema = exports.isSrsInfo = exports.SrsInfoSchema = exports.isWordFlashcardAttributes = exports.WordFlashcardAttributesSchema = exports.SentenceFlashcardAttributesSchema = exports.isFlashcardCreator = exports.FlashcardCreatorSchema = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../../helpers/type_validation_helpers");
const image_association_types_1 = require("../image_association_types");
const sentence_word_types_1 = require("../sentence/sentence_word_types");
const flashcard_type_types_1 = require("./flashcard_type_types");
exports.FlashcardCreatorSchema = zod_1.z.union([
    zod_1.z.literal("fluent_forever"),
    zod_1.z.literal("user"),
]);
exports.isFlashcardCreator = type_validation_helpers_1.getTypeValidationFunction(exports.FlashcardCreatorSchema);
exports.SentenceFlashcardAttributesSchema = zod_1.z.object({
    sentence_id: zod_1.z.string(),
    sentence_word: sentence_word_types_1.SentenceWordSchema,
    tag_ids: zod_1.z.string().array(),
});
exports.WordFlashcardAttributesSchema = zod_1.z.object({
    created_by: exports.FlashcardCreatorSchema,
    is_custom_translation: zod_1.z.boolean().optional(),
    is_extended_word: zod_1.z.boolean().optional(),
    word_audio_url: zod_1.z.string().optional(),
    word_entry_id: zod_1.z.string().optional(),
    word_ipa_txt: zod_1.z.string().optional(),
    word_known_txt: zod_1.z.string(),
    word_learn_gender: zod_1.z.string().optional(),
    word_learn_id: zod_1.z.string(),
    word_learn_reading: zod_1.z.string().optional(),
    word_learn_txt: zod_1.z.string(),
    word_learn_txt_diacritics: zod_1.z.string().optional(),
});
exports.isWordFlashcardAttributes = type_validation_helpers_1.getTypeValidationFunction(exports.WordFlashcardAttributesSchema);
exports.SrsInfoSchema = zod_1.z.object({
    easiness_factor: zod_1.z.number(),
    interval: zod_1.z.number(),
    next_scheduled: zod_1.z.string().optional(),
    repetition: zod_1.z.number(),
});
exports.isSrsInfo = type_validation_helpers_1.getTypeValidationFunction(exports.SrsInfoSchema);
exports.FlashcardWithoutPicturesBaseSchema = exports.SrsInfoSchema.extend({
    id: zod_1.z.string(),
    type: zod_1.z.string(),
});
exports.FlashcardBaseSchema = exports.FlashcardWithoutPicturesBaseSchema.extend({
    images: image_association_types_1.ImageSchema.array(),
});
exports.BasicFlashcardInfoSchema = exports.SrsInfoSchema.merge(zod_1.z.object({
    customTranslationId: zod_1.z.string().optional(),
    extendedWordId: zod_1.z.string().optional(),
    id: zod_1.z.string(),
    premadeFlashcardWordId: zod_1.z.string().optional(),
    sentenceWordId: zod_1.z.string().optional(),
    typeName: flashcard_type_types_1.AnyFlashcardTypeSchema.optional(),
    ugcFlashcardId: zod_1.z.string().optional(),
    wordEntryId: zod_1.z.string().optional(),
    wordId: zod_1.z.string().optional(),
}));
exports.isBasicFlashcardInfo = type_validation_helpers_1.getTypeValidationFunction(exports.BasicFlashcardInfoSchema);
//# sourceMappingURL=flashcard_common_types.js.map